// extracted by mini-css-extract-plugin
module.exports = {"image":"Workout_image__1QZMh","fadeIn":"Workout_fadeIn__2Ufyz"};